import Router from 'vue-router'
import HomePage from './components/HomePage.vue' 
import CaseList from './components/CaseList.vue' 
import DicomViewer from './components/dicom/DicomViewer.vue'
import DicomUpload from './components/dicom/DicomUpload.vue'
//import Playlists from './components/playlists/Playlists.vue'
//import PlaylistInterface from './components/playlists/PlaylistInterface.vue'
import Classrooms from './components/classrooms/Classrooms.vue'
import ClassroomViewer from './components/classrooms/ClassroomViewer.vue'
import ClassroomLearnerDashboard from './components/classrooms/ClassroomLearnerDashboard.vue'
import AssignmentCaseDashboard from './components/classrooms/AssignmentCaseDashboard.vue'
import CaseViewer from './components/CaseViewer.vue' 
import PanelPresetViewer from './components/slides/PanelPresetViewer.vue'
import CaseEditor from './components/CaseEditor.vue' 
import CaseEditorDashboard from './components/editors/CaseEditorDashboard.vue'
import Scoreboard from './components/Scoreboard.vue' 
import CaseDiscussion from './components/CaseDiscussion.vue'
import PrivacyPolicy from './components/PrivacyPolicy.vue'
import TOS from './components/TOS.vue'
import Support from './components/Support.vue'
import UserSettings from './components/UserSettings.vue'
import UserProfile from './components/UserProfile.vue'
import AdminUserProfile from './components/admin/AdminUserProfile.vue'
import AdminSettings from './components/admin/AdminSettings.vue'
import Authorize from './components/Authorize.vue'
import Login from './components/Login.vue'
import Logout from './components/Logout.vue'
import Error404 from './components/404.vue'

export default function(vueInstance){
  vueInstance.use(Router)
  return new Router({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'home',
        component: HomePage
      },
      {
        path: '/cases/:caseID/',
        component: CaseViewer, 
        props: true
      },
      {
        path: '/cases/:caseID/discuss',
        component: CaseDiscussion, 
        props: true
      },
      {
        path: '/cases/:caseID/attempt/:attemptString',
        component: CaseViewer, 
        props: true
      },
      {
        path: '/cases/',
        component: CaseList
      },
      {
        path: '/dicom/:folderName',
        component: DicomViewer,
        props: true
      },
      {
        path: '/dicom/upload/',
        component: DicomUpload
      },
      {
        path: '/editor/:caseID/dashboard',
        component: CaseEditorDashboard, 
        props: true
      },
      {
        path: '/editor/:caseID/:slideIndex?',
        component: CaseEditor, 
        props: true
      },
      {
        path: '/panel_presets/:presetID',
        component: PanelPresetViewer,
        props: true
      },
      {
        path: "/classroom/:classroomID",
        component: ClassroomViewer,
        props: true
      },
      {
        path: "/classroom/:classroomID/learner/:learnerID/",
        component: ClassroomLearnerDashboard,
        props: true
      },
      {
        path: "/classroom/:classroomID/dashboard/:assignmentID/:caseID",
        component: AssignmentCaseDashboard,
        props: true
      },
      {
        path: "/classrooms*",
        component: Classrooms,
      },
      /*{
        path: "/playlist/:playlistID",
        component: PlaylistInterface,
        props: true
      },
      {
        path: "/playlists/*",
        component: Playlists,
      },*/
      {
        path: '/editor/',
        component: CaseList
      },
      {
        path: '/settings*',
        component: UserSettings
      },
      {
        path: '/user/:publicID',
        component: UserProfile,
        props: true
      },
      {
        path: '/admin/user/:userID',
        component: AdminUserProfile,
        props: true
      },
      {
        path: '/admin*',
        component: AdminSettings
      },
      {
        path: '/scoreboard*',
        component: Scoreboard
      },
      {
        path: '/privacy',
        component: PrivacyPolicy
      },
      {
        path: '/tos',
        component: TOS
      },
      {
        path: '/support',
        component: Support
      },
      {
        path: '/auth/:provider',
        component: Authorize,
        props: true
      },
      {
        path: '/login',
        component: Login,
      },
      {
        path: '/logout',
        component: Logout,
        props: true
      },
      {
        path: "*",
        component: Error404
      }
    ]
  })
}
